import React from 'react';
import PropTypes from 'prop-types';

import { uppercaseFirst, convertCamelCaseToSentenceCase } from 'shared/helpers/string';

const ValidationErrorDetails = ({ errors: errorsByField }) => (
    <>
        <ul>
            {errorsByField.map(({ field, errors }) =>
                errors.map(error => (
                    <li>
                        {uppercaseFirst(convertCamelCaseToSentenceCase(field))} {error}
                    </li>
                ))
            )}
        </ul>
    </>
);

ValidationErrorDetails.propTypes = {
    errors: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default ValidationErrorDetails;
